import React from 'react'
import {Divider, Row, Space} from "antd";
import AppList from "../../components/list";
import AppButton from "../../components/button";
import {Link} from "react-router-dom";
import {connect} from "react-redux";
import {setProject} from "../../redux/actions";

const projects = [
    {
        name:'Texas Hold ’em Poker (Nevada Ruleset)',
        id: '239480812',
        status:'Pending'
    },
    {
        name:'Symbian Horse Racing',
        id: '097680912',
        status:'Pending'
    },
    {
        name:'Math Games Plus',
        id: '44280812',
        status:'Voting'
    }
]

const ProjectsList = ({
    ...props
})=>{

    return(

        <div className={'container-sm'}>
            <div style={{height:120}}/>
            <AppList
                className={'black-bg no-padding'}
                header={

                    <Row justify={'space-between'}
                             align={'middle'}
                className={'white10-bg heading-padding'}
                >
                        <h2>My Games</h2>

                    <AppButton glow
                               to={'/projects/create'}
                    >
                        ADD NEW
                    </AppButton>

                </Row>}

                items={
                    projects
                }
                render={(item)=><Link
                // to={'/projects/'+item.id}
                onClick={()=>{
                    console.log('item clicked')
                    props.dispatch(setProject(item))
                    props.history.push('/projects/'+item.id)
                }}
                ><div className={' pointer highlight-hover'}

                ><Row type={'flex'} justify={'space-between'} align={'middle'} className={'padding'}>
                    <h3>{item.name}</h3>
                    <h5>{item.status}</h5>
                </Row>
                <Divider className={'white10-bg no-margin'}/>
                </div>
                </Link>
                    }
            />
        </div>
    )
}

export default connect()(ProjectsList)